// extracted by mini-css-extract-plugin
export var productImage = "_pp-1";
export var viewLink = "_pp-2";
export var wishlistItem = "_pp-0";